<template>
    <b-row>
        <b-col sm="12" md="12" lg="12" xl="12">
            <b-card no-body>
                <b-card-body>
                    <h4 class="heading-1 mb-4">
                        <span
                            >APP Sebrae - Consultorias - Unidade Regional</span
                        >
                        <div class="float-right">
                            <span class="text-primary">
                                <i
                                    class="fa fa-refresh fa-lg icon-button"
                                    title="Atualizar"
                                    @click.stop="obterUnidadeRegional()"
                                ></i>
                            </span>
                        </div>
                    </h4>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <b-row>
                        <b-col sm="12" v-if="unidadeRegional">
                            <app-k-v titulo="Nome" :md="md" :lg="lg" :xl="xl"
                                ><strong>{{
                                    unidadeRegional.nome
                                }}</strong></app-k-v
                            >
                            <app-k-v titulo="Gestor" :md="md" :lg="lg" :xl="xl"
                                ><strong>{{
                                    unidadeRegional.nomeGestor
                                }}</strong>
                            </app-k-v>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" v-if="unidadeRegional">
                            <h5 class="heading-1 mt-4 mb-4">
                                <span>Dotação Orçamentária</span>
                            </h5>
                            <app-k-v titulo="Unidade" :md="md" :lg="lg" :xl="xl"
                                ><strong
                                    >{{ unidadeRegional.unidade }} ({{
                                        unidadeRegional.codUnidade
                                    }}</strong
                                >)
                            </app-k-v>
                            <app-k-v titulo="Projeto" :md="md" :lg="lg" :xl="xl"
                                ><strong
                                    >{{ unidadeRegional.projeto }} ({{
                                        unidadeRegional.codProjeto
                                    }}</strong
                                >)
                            </app-k-v>
                            <app-k-v titulo="Ação" :md="md" :lg="lg" :xl="xl"
                                ><strong
                                    >{{ unidadeRegional.acao }} ({{
                                        unidadeRegional.codAcao
                                    }}</strong
                                >)
                            </app-k-v>
                        </b-col>
                        <b-col sm="12" v-if="unidadeRegional" class="mt-2">
                            <app-btn-voltar
                                rota="AppSebrae_Consultorias_UnidadesRegionais"
                            ></app-btn-voltar>
                            <btn-atualizar-unidade-regional
                                :unidadeRegional="unidadeRegional"
                                class="ml-2"
                            ></btn-atualizar-unidade-regional>
                        </b-col>
                    </b-row>
                    <unidade-regional-municipios
                        :unidadeRegional="unidadeRegional"
                        v-if="unidadeRegional"
                        @obterUnidadeRegionalAtualizada="obterUnidadeRegional()"
                    ></unidade-regional-municipios>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import UnidadesRegionaisServicos from './UnidadesRegionaisServicos'
import UnidadeRegionalMunicipios from './UnidadeRegionalMunicipios'
import BtnAtualizarUnidadeRegional from './BtnAtualizarUnidadeRegional'

export default {
    data() {
        return {
            erros: [],
            xl: 1,
            lg: 1,
            md: 1,
            unidadeRegional: null
        }
    },

    methods: {
        obterUnidadeRegional() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterPorId(
                this.$route.params.unidadeRegionalId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidadeRegional = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterUnidadeRegional()
    },

    components: {
        UnidadeRegionalMunicipios,
        BtnAtualizarUnidadeRegional
    }
}
</script>